import { LayoutProps } from 'piral-core'
import * as React from 'react'
import './Layout.scss'
import { Tracker } from 'piral-tracker'
import { ThemeProvider, useTheme } from '../theming';

export default function Layout(props: LayoutProps) {

    React.useEffect(() => {
        dispatchEvent(new CustomEvent('talisman:loaded'));
    }, []);

    return (
        <ThemeProvider>
            <ThemedLayout>
                <Tracker></Tracker>
                {props.children}
            </ThemedLayout>
        </ThemeProvider>
    )
}

function ThemedLayout(props: any) {
    const [theme, setTheme] = useTheme()

    const isDark = theme?.color === 'dark' || theme?.followSystem === true && window.matchMedia('(prefers-color-scheme: dark)').matches

    return (
        <sp-theme class='default' color={isDark ? 'dark' : 'light'} system={theme?.system ?? 'spectrum'} scale={theme?.scale ?? 'medium'}>
            {props.children}
        </sp-theme>
    )
}